import React from 'react';
import { PaymentMarks } from './PaymentMarks';
import { SocialChannels } from './SocialChannels';
import { ClocheGlyph, ConciergeGlyph, CrestGlyph, GulfstreamGlyph, HypercarGlyph } from './RequestIcons';
import { conciergeExtras } from '../data/content';

// Same drawn, solid glyphs as the hero request bar
const icons = {
  car: HypercarGlyph,
  utensils: ClocheGlyph,
  plane: GulfstreamGlyph,
  shield: CrestGlyph,
  plus: ConciergeGlyph
};
export function ConciergeExtras() {
  return <section aria-labelledby="extras-heading" className="bg-paper px-6 pb-24 md:px-16 md:pb-36" data-id="element-201" data-mp="hzy6lmbmsdjj">
      <h2 id="extras-heading" className="font-editorial text-[34px] font-normal leading-[38px] tracking-[-0.01em] md:text-[44px] md:leading-[48px]" data-id="element-202" data-mp="d97yi1btlwl5">
        Looking for more than an introduction?
      </h2>

      <ul className="mt-8 grid grid-cols-2 gap-px border border-line bg-line sm:grid-cols-3 md:mt-10 lg:grid-cols-5" data-id="element-203" data-mp="15qu3uyyuw0y6">
        {conciergeExtras.map(item => {
        const Icon = icons[item.icon];
        const isAll = item.icon === 'plus';
        return (
          // "All concierge services" spans the full row on mobile so the grid closes evenly
          <li key={item.label} className={`bg-bone ${isAll ? 'col-span-2 sm:col-span-1' : ''}`} data-id="element-204" data-mp="2yqkklg3stlk8">
              <div className={`group flex h-full flex-col items-center justify-center gap-3 px-3 text-center transition-colors duration-300 hover:bg-mist sm:min-h-[160px] sm:gap-5 sm:px-4 sm:py-10 md:min-h-[176px] ${isAll ? 'min-h-[72px] flex-row py-5 sm:flex-col' : 'min-h-[112px] py-6'}`} data-id="element-205" data-mp="33om2hxphneu4">
                <Icon className="h-7 w-[60px] shrink-0 text-ink transition-transform duration-300 ease-out group-hover:-translate-y-0.5 sm:h-9 sm:w-[76px] rtl:-scale-x-100" data-id="element-206" data-mp="2ft9og4dgr890" />
                <span className="whitespace-nowrap text-[11px] font-bold uppercase leading-[16px] tracking-[0.02em] sm:text-[13px] sm:leading-[18px]" data-id="element-207" data-mp="e0bolol9rfek">{item.label}</span>
              </div>
            </li>
        );
      })}
      </ul>

      {/* Payment (left) · Instagram channels (right) */}
      <div className="mt-16 grid grid-cols-1 gap-14 border-b border-line pb-16 md:mt-24 md:pb-20 lg:grid-cols-[minmax(0,1fr)_minmax(0,1.15fr)] lg:gap-20" data-id="element-208" data-mp="chv8wind8r90">
        <div data-id="element-209" data-mp="3i83zmvfh3b7">
          <h3 className="text-[14px] font-bold uppercase tracking-[0.02em]" data-id="element-210" data-mp="3igljs2hwwsq">Settled Discreetly</h3>
          <PaymentMarks data-id="element-211" data-mp="108qyd94cnad3" />
        </div>
        <div data-id="element-212" data-mp="107pgakox1nlv">
          <SocialChannels data-id="element-213" data-mp="10abommjms755" />
        </div>
      </div>
    </section>;
}